export default __webpack_public_path__ + "static/media/App-Store-Icon.21ffdcc6.svg";